module.exports = __webpack_public_path__ + "static/media/BrianBalayon.1d439eb6.png";